// Function to send analytics data
const sendAnalyticsdata = (objectValue) => {
  if (typeof Analytics_Util !== "undefined") {
    Analytics_Util._pushAnalyticsEvent(objectValue);
  }
};

export { sendAnalyticsdata };
